import React, { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { color, r } from '../../theme/tokens';
import './NewsletterSignup.css';

/**
 * Reusable Newsletter Signup Component
 * Displays embedded MailerLite newsletter form using direct HTML embed
 * Used across blog pages and landing page
 */
export default function NewsletterSignup() {
  
  useEffect(() => {
    // Load the MailerLite webforms script once
    if (!document.querySelector('script[src*="groot.mailerlite.com"]')) {
      const script = document.createElement('script');
      script.src = 'https://groot.mailerlite.com/js/w/webforms.min.js?v176e10baa5e7ed80d35ae235be3d5024';
      script.type = 'text/javascript';
      script.async = true;
      document.body.appendChild(script);
    }

    // Fetch MailerLite tracking pixel
    if (!window.ml_webform_success_31287176) {
      fetch("https://assets.mailerlite.com/jsonp/1682174/forms/166464886000322231/takel");
    }
  }, []);

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: color.surface,
      py: { xs: 4, md: 6 },
      borderTop: `${r(1)} solid ${alpha(color.evergreen, 0.1)}`,
      borderBottom: `${r(1)} solid ${alpha(color.evergreen, 0.1)}`
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center' }}>
          <div 
            id="mlb2-31287176" 
            className="ml-form-embedContainer ml-subscribe-form ml-subscribe-form-31287176"
            dangerouslySetInnerHTML={{
              __html: `
                <style type="text/css">
                  @import url("https://assets.mlcdn.com/fonts.css?version=1758802");
                </style>
                <div class="ml-form-align-center">
                  <div class="ml-form-embedWrapper embedForm">
                    <div class="ml-form-embedBody ml-form-embedBodyHorizontal row-form">
                      <div class="ml-form-embedContent" style="">
                        <h4>Get the myStack Digest</h4>
                        <p><br></p>
                        <p>The latest science-backed insights from our nutrition scientists, delivered weekly.</p>
                        <p><br></p>
                      </div>
                      <form class="ml-block-form" action="https://assets.mailerlite.com/jsonp/1682174/forms/166464886000322231/subscribe" data-code="" method="post" target="_blank">
                        <div class="ml-form-formContent horozintalForm">
                          <div class="ml-form-horizontalRow">
                            <div class="ml-input-horizontal">
                              <div style="width: 100%;" class="horizontal-fields">
                                <div class="ml-field-group ml-field-email ml-validate-email ml-validate-required">
                                  <input type="email" class="form-control" data-inputmask="" name="fields[email]" placeholder="Email" autocomplete="email">
                                </div>
                              </div>
                            </div>
                            <div class="ml-button-horizontal primary">
                              <button type="submit" class="primary">Join</button>
                              <button disabled="disabled" style="display: none;" type="button" class="loading">
                                <div class="ml-form-embedSubmitLoad"></div>
                                <span class="sr-only">Loading...</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        <input type="hidden" name="ml-submit" value="1">
                        <div class="ml-mobileButton-horizontal">
                          <button type="submit" class="primary">Join</button>
                          <button disabled="disabled" style="display: none;" type="button" class="loading">
                            <div class="ml-form-embedSubmitLoad"></div>
                            <span class="sr-only">Loading...</span>
                          </button>
                        </div>
                        <input type="hidden" name="anticsrf" value="true">
                      </form>
                    </div>
                    <div class="ml-form-successBody row-success" style="display: none">
                      <div class="ml-form-successContent">
                        <h4>Welcome to the Digest!</h4>
                        <p style="text-align: center;">You're all set. While you wait for your first Digest, explore our latest <a href="https://my-stack.ai/blog">Insights</a>, for clear, science-based guidance.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <script>
                  function ml_webform_success_31287176() {
                    var $ = ml_jQuery || jQuery;
                    $('.ml-subscribe-form-31287176 .row-success').show();
                    $('.ml-subscribe-form-31287176 .row-form').hide();
                  }
                </script>
              `
            }}
          />
        </Box>
      </Container>
    </Box>
  );
}

